module.exports = __webpack_public_path__ + "img/UCG_ativo.00a55b1d.png";